let currentItem = null;

function showImage(event, src, item) {
  // Aggiunge un controllo per la larghezza dello schermo
  if (window.innerWidth > 768) {
    if (currentItem !== item) {
      currentItem = item;
      const img = document.getElementById("hover-img");
      img.src = src;
      img.style.display = "block";
      img.classList.remove("rotate-animation");
      void img.offsetWidth;
      img.classList.add("rotate-animation");

      centerImageVertically(item);
      document.addEventListener("mousemove", moveImage);
    }
  }
}

function hideImage(event) {
  // Aggiunge un controllo per la larghezza dello schermo
  if (window.innerWidth > 768) {
    const img = document.getElementById("hover-img");
    img.style.display = "none";
    img.classList.remove("rotate-animation");
    document.removeEventListener("mousemove", moveImage);
    currentItem = null;
  }
}

function centerImageVertically(item) {
  if (window.innerWidth > 768) {
    const img = document.getElementById("hover-img");
    const rect = item.getBoundingClientRect();
    const centerY = rect.top + rect.height / 2 - img.offsetHeight / 2;
    img.style.top = `${centerY}px`;
    img.style.left = `${event.clientX + 10}px`;
  }
}

function moveImage(event) {
  if (window.innerWidth > 768) {
    const img = document.getElementById("hover-img");
    img.style.left = `${event.clientX + 10}px`;
  }
}

function handleScroll() {
  var leftBlock = document.querySelector(".left");
  var rect = leftBlock.getBoundingClientRect();
  if (
    rect.top >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  ) {
    leftBlock.classList.add("visible");
  }
}

window.addEventListener("scroll", handleScroll);
window.addEventListener("load", handleScroll);
